<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body" *ngIf="message">
    {{message}}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" [class]="options.confirmBtnClass" (click)="confirm()">
        {{options.confirmBtnText}}
    </button>
    <button type="button" class="btn btn-danger" [class]="options.cancelBtnClass" (click)="cancel()">
        {{options.cancelBtnText}}
    </button>
</div>